// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var AccountLocationPurposeType;
(function (AccountLocationPurposeType) {
    AccountLocationPurposeType[AccountLocationPurposeType["UNKNOWN"] = 0] = "UNKNOWN";
    AccountLocationPurposeType[AccountLocationPurposeType["CORPORATEHEADQUARTERS"] = 1] = "CORPORATEHEADQUARTERS";
    AccountLocationPurposeType[AccountLocationPurposeType["SALESOFFICE"] = 2] = "SALESOFFICE";
    AccountLocationPurposeType[AccountLocationPurposeType["RESIDENTIALADDRESS"] = 3] = "RESIDENTIALADDRESS";
    AccountLocationPurposeType[AccountLocationPurposeType["WORKADDRESS"] = 4] = "WORKADDRESS";
    AccountLocationPurposeType[AccountLocationPurposeType["SEASONALADDRESS"] = 5] = "SEASONALADDRESS";
    AccountLocationPurposeType[AccountLocationPurposeType["MAILINGADDRESS"] = 6] = "MAILINGADDRESS";
    AccountLocationPurposeType[AccountLocationPurposeType["BILLINGADDRESS"] = 7] = "BILLINGADDRESS";
    AccountLocationPurposeType[AccountLocationPurposeType["SHIPPINGADDRESS"] = 8] = "SHIPPINGADDRESS";
})(AccountLocationPurposeType || (AccountLocationPurposeType = {}));
//# sourceMappingURL=accountLocationPurposeType.js.map